<style scoped>
h2 {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.thermo-king-footer {
  font-size: 10px;
}
</style>

<template>
  <b-container class="mb-5 pt-4">
    <b-row>
      <b-col cols="6" md="3">
        <a href="/">
          <b-img
            src="../assets/aesssa-logo.png"
            alt="aesssa-logo"
            class="aesssa-logo"
          />
        </a>
      </b-col>
      <b-col cols="6" md="9" class="text-right">
        <b-col>
          <b-img
            src="../assets/thermo-king-logo.png"
            alt="thermo-king-logo"
            class="thermo-king-logo"
          />
        </b-col>
        <b-col class="p-0">
          <span class="thermo-king-footer">
            Distribuidor autorizado
          </span>
        </b-col>
      </b-col>
      <b-col cols="12" class="mt-2">
        <h2>{{ title }}</h2>
      </b-col>
    </b-row>
    <b-row v-show="userEmail">
      <b-col cols="12">
        <span class="float-right">
          <b-avatar></b-avatar>
          <span class="mr-1">
            {{ userEmail }}
          </span>
        </span>
      </b-col>
      <b-col>
        <b-button-group class="float-right">
          <b-button variant="info" @click="goToUsers" size="sm" v-if="isAdmin"
            >Usuarios</b-button
          >
          <b-button variant="default" @click="doLogOut" size="sm">
            Salir
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Header",
  props: {
    title: String,
  },
  computed: {
    userEmail: {
      get() {
        return this.getUserEmail;
      },
    },
    ...mapGetters("auth", ["getUserEmail", "isAdmin"]),
  },
  methods: {
    ...mapActions("auth", ["logOut"]),
    doLogOut() {
      this.logOut().then(() => {
        this.$router.push("/");
      });
    },
    goToUsers() {
      this.$router.push("/users");
    },
  },
};
</script>
